import React from "react";

export default function WhyChoose() {
  return (
    <section
      id="about"
      data-testid="why-choose-section"
      className="relative bg-[#16332d] text-white"
    >
      <div className="container-vlx py-24 md:py-36">
        {/* Catalog-style intro */}
        <div className="grid md:grid-cols-12 gap-10 md:gap-16 items-start">
          <div className="md:col-span-5">
            <span className="eyebrow eyebrow-light">The ViewLux Difference</span>
            <div className="mt-4 rule-gold" />
            <h2 className="heading-lg mt-8 text-[36px] md:text-[60px] text-white">
              Why architects choose ViewLux{" "}
              <em className="italic text-[#e2b880] font-light">
                thermally broken aluminum.
              </em>
            </h2>
          </div>
          <div className="md:col-span-7 md:pl-12 md:pt-6">
            <p className="text-white/75 text-[15.5px] leading-[1.95] font-nunito">
              At ViewLux, we don't take shortcuts. We engineer aluminum windows
              and doors for modern architecture — precise, refined, and
              uncompromising. Unlike mass-produced systems with fixed limits,
              ViewLux is built around flexibility. Each project allows true
              customization in size, configuration, and finish, giving
              architects and builders full design freedom.
            </p>
            <p className="text-white/65 text-[15px] leading-[1.95] font-nunito mt-6">
              Our thermally broken systems provide the strength for large
              openings while meeting today's energy standards. From fabrication
              to glazing, every system is manufactured for consistency,
              durability, and long-term performance.
            </p>
          </div>
        </div>

        {/* Catalog data blocks */}
        <div className="mt-20 md:mt-28 grid md:grid-cols-3 gap-px bg-[#c99658]/20">
          {[
            {
              num: "01",
              title: "Engineered Flexibility",
              desc: "Each project allows true customization in size, configuration, and finish — giving architects and builders full design freedom.",
            },
            {
              num: "02",
              title: "Thermally Broken",
              desc: "Strength for large openings while exceeding today's energy standards — built for extreme climates and demanding sites.",
            },
            {
              num: "03",
              title: "Partnership Approach",
              desc: "We collaborate with architects, builders, and homeowners to deliver refined, high-performing aluminum systems built to last.",
            },
          ].map((f, i) => (
            <div
              key={f.num}
              data-testid={`feature-card-${i}`}
              className="group relative p-10 md:p-12 bg-[#16332d] transition-colors duration-500 hover:bg-[#0f2420]"
            >
              <div className="font-cormorant italic text-[#e2b880] text-5xl md:text-6xl mb-8 transition-transform duration-500 group-hover:translate-x-1">
                {f.num}
              </div>
              <h3 className="heading-lg text-[24px] md:text-[28px] text-white mb-5">
                {f.title}
              </h3>
              <p className="text-white/70 text-[14.5px] leading-[1.85] font-nunito">
                {f.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
